import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "delete-account" */ './AccountDelete'));
